// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j5MTd","question":"styles_question__lzC6J","inputVisibleButton":"styles_inputVisibleButton__1kj5b","note":"styles_note__2mifq"};